const PRERENDERING_FLAG = '_isAppPrerendering';

export const isAppPrerendering = !!window[PRERENDERING_FLAG];
